var _defs, _rect, _path, _path2, _polyline, _polyline2, _rect2, _line, _polygon, _polygon2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCp2StickerOnGlassIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d,.f{fill:none;}.b{fill:#ffefe0;}.b,.c{stroke:#3c3c46;stroke-width:2px;}.b,.c,.d,.f{stroke-linecap:round;stroke-linejoin:round;}.b,.c,.d,.g{fill-rule:evenodd;}.c{fill:#89d9fb;}.d,.f{stroke:#e5e5e5;stroke-width:2px;}.e{fill:#6e6e78;opacity:0.2;}.g{fill:#fff;opacity:0.7;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-sticker-on-glass-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M69.1,34C66.07,51.7,80,73.09,93.9,73.1L90.79,55.67Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M84.68,61.78C75.35,52.46,59.2,59,59.2,72.34S75.35,92.21,84.68,82.89l16.83,16.83A38.73,38.73,0,1,1,69.15,33.93L90.84,55.62Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "128 135 128 12 12 12 12 135"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "135 135 135 5 5 5 5 135"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 17,
    y: 17,
    width: 106,
    height: 118
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 12,
    y1: 135,
    x2: 5,
    y2: 135
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "17 70.65 109.93 17 77.46 17 17 51.91 17 70.65"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "17 46.91 68.81 17 53.06 17 17 37.82 17 46.91"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCp2StickerOnGlassIcon);
export default __webpack_public_path__ + "static/media/CP2-sticker-on-glass-icon.658780ccb16804c8c6dc59415d155de9.svg";
export { ForwardRef as ReactComponent };